import { selectPillarByVeto } from './VetosByPillar';
export function prepareQoSEvent(event) {
    // Fill in ASHA event with default values where necessary
    const qosEvent = {
        ...event,
        // Temporary: Since current OWH ASHA logs predefine a pillar,
        // preserve that specified pillar otherwise we should map veto to known pillars
        pillar: event.pillar ?? selectPillarByVeto(event.veto),
        isIntentional: event.isIntentional ?? false,
        isInternal: event.isInternal ?? true,
        alertOnPillar: event.alertOnPillar ?? true,
        isSessionEndingError: event.isSessionEndingError ?? false
    };
    return qosEvent;
}
export function isQoSEvent(event) {
    return 'eventName' in event && 'veto' in event;
}
//# sourceMappingURL=prepareQosEvent.js.map